import React from 'react'

import { List } from '@chakra-ui/react'
import VirtualList from 'react-tiny-virtual-list'

const itemHeight = 50

const CustomMenuList = ({ options, children, maxHeight, getValue }) => {
  const [value] = getValue()
  const childrenOptions = React.Children.toArray(children)
  const wrapperHeight =
    maxHeight < childrenOptions.length * itemHeight ? maxHeight : childrenOptions.length * itemHeight

  const initialOffset = wrapperHeight < maxHeight ? 0 : options.indexOf(value) * itemHeight

  const renderItem = (props) => {
    if (Array.isArray(children)) {
      return (
        <li style={props.style} key={props.index}>
          {children[props.index]}
        </li>
      )
    }
    return <li key={props.index}>{children.props.children}</li>
  }

  return (
    <List>
      <VirtualList
        width="100%"
        height={wrapperHeight + 10}
        scrollOffset={initialOffset}
        itemCount={childrenOptions.length}
        itemSize={itemHeight}
        renderItem={renderItem}
      />
    </List>
  )
}

export default CustomMenuList
